import React, {useEffect} from 'react'
import {toast} from 'react-toastify'
import {useLocation} from 'react-router-dom'
import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {routes} from 'routes/routes'
import {FullPageLoader} from 'attendee/theme/FullPageLoader'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'
import {useI18n} from 'i18n/I18nContext'

export function GoogleCallback() {
  const {googleCallback} = useAuth()
  const location = useLocation()
  const navigate = useLocalizedNavigate()
  const {t} = useI18n()

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const result = await googleCallback(location.search)
      if (!cancelled && result === true) {
        toast.success(t('auth.loginSuccess'))
      }
      if (!cancelled) {
        navigate(routes.index)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [googleCallback, location.search, navigate, t])

  return <FullPageLoader />
}
